module.exports = __webpack_public_path__ + "static/media/wrong.bbfd7373.gif";